/**
 * @module NotificationTypeBadge
 * @package @geenius/notifications-solidjs-css
 * @description Renders a small semantic badge for a notification type in the
 * SolidJS vanilla CSS variant.
 */

import type { NotificationType } from '@geenius/notifications/shared'
import { getNotificationTypeLabel, TYPE_CONFIG } from '@geenius/notifications/shared'
import type { JSX } from 'solid-js'
import { cx } from '../lib/cx'
import { createNotificationCopy } from '../lib/notificationCopy'

/**
 * Props for the notification type badge.
 */
export interface NotificationTypeBadgeProps {
  type: NotificationType
  class?: string
}

/**
 * Renders a semantic badge for a notification type.
 *
 * @param props Badge props.
 * @returns The rendered badge.
 */
export function NotificationTypeBadge(
  props: NotificationTypeBadgeProps,
): JSX.Element {
  const { t } = createNotificationCopy()
  const config = () => TYPE_CONFIG[props.type]

  return (
    <span
      class={cx(
        'notifications__type-badge',
        `notifications__type-badge--${props.type}`,
        props.class,
      )}
    >
      {config().icon} {getNotificationTypeLabel(props.type, t)}
    </span>
  )
}
